module.exports = __webpack_public_path__ + "static/1-34f1f70c09588580fba7b460da70e204.jpg";